import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNoraShowMoreChevron = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.167 8.3335L10.1966 12.3039C10.1709 12.3297 10.1403 12.3501 10.1066 12.3641C10.0729 12.3781 10.0368 12.3853 10.0003 12.3853C9.96386 12.3853 9.92776 12.3781 9.89408 12.3641C9.86039 12.3501 9.82979 12.3297 9.80403 12.3039L5.83366 8.3335",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgNoraShowMoreChevron;
